import React from 'react';
import ClinicConditionsList from '../../ClinicConditionList';
import { ClinicFormProps, ClinicIdProps } from '../../../../CreateClinic/types';

function ModifyClinicConditionsBody(props: ClinicFormProps & ClinicIdProps) {
  return <ClinicConditionsList {...props} />;
}

export default ModifyClinicConditionsBody;
